<!-- 产品-设备详情 -->
<template>
  <div>
    <!-- 卡片-主体-查询表单 -->
    <div class="md-layout card-form">
      <div class="md-layout md-layout-item md-size-60 md-xsmall-size-100">
        <!-- 表单-输入栏-查询类型 {cdk: CDK, order_id: 查询MAC} -->
        <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
          <md-field>
            <md-select v-model="searchForm.searchType" >
              <md-option value="cdk">{{$I18n("cdk")}}</md-option>
              <md-option value="order_id">{{$I18n('order_id')}}</md-option>
            </md-select>
          </md-field>
        </div>
        <!-- 表单-输入栏-查询参数 (与 searchType 对应) -->
        <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
          <md-field>
            <label v-if="searchForm.searchType === 'cdk'">{{$I18n("cdk")}}</label>
            <label v-if="searchForm.searchType === 'order_id'">{{$I18n('order_id')}}</label>
            <md-input v-model="searchForm.searchValue"/>
          </md-field>
        </div>
        <!-- 表单-选择栏-设备状态 {0: 全部, 1: 已使用, 2: 待使用, 3: 已过期 } -->
        <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
          <md-field>
            <label>{{$I18n("state")}}</label>
            <md-select v-model="searchForm.state">
              <md-option value="0">{{$I18n('all')}}</md-option>
              <md-option value="1">{{$I18n('used')}}</md-option>
              <md-option value="2">{{$I18n('to_be_used')}}</md-option>
              <md-option value="3">{{$I18n('is_outfo_date')}}</md-option>
            </md-select>
          </md-field>
        </div>
        <!-- 表单-选择栏-选择公司ID -->
        <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
          <md-field>
            <label>{{$I18n("company")}}{{searchForm.company}}</label>
            <md-select v-model="searchForm.comp_id">
              <md-option v-for="comp in compData" :key  ="comp.comp_id" :value="comp.comp_id">
                {{comp.comp_name}}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
        <div class="md-layout-item md-size-50 left-layout-item" v-if="$root.state.mobile" :style="{'padding-right':0}">
          <md-button class= "left-icon md-info right-button md-just-icon" @click="form_changeSearchData">
            <md-icon>search</md-icon>
          </md-button>
        </div>
      </div>
      <!-- 表单-按钮- -->
      <div class="md-layout md-layout-item md-size-40 md-xsmall-size-100">
        <!-- 表单-按钮-重新查询 (只在大屏幕中显示) -->
        <div class="md-layout-item md-size-25" v-if="!$root.state.mobile">
          <md-button class= "left-icon md-info" @click="form_changeSearchData">
            <md-icon>search</md-icon>
            {{$I18n("search")}}
          </md-button>
        </div>
      </div>
    </div>
    <!-- 卡片-主体-内容表格 
      批次ID
      所属企业
      CDK
      订单ID
      状态
      版本
      创建时间
     -->
    <div class="md-layout card-form">
      <md-table class="md-layout md-size-100 md-layout-item" v-model="tableData">
        <md-table-row slot="md-table-row" slot-scope="{ item }" >
          <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('act_code_order')">{{ item.cdk_order_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
          <md-table-cell :md-label="$I18n('cdk')">{{ item.cdk }}</md-table-cell>
          <md-table-cell :md-label="$I18n('spec_name')">{{ item.spce_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('simple_order_id')">{{ item.order_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('expire_time')">{{ item.expire_date }}</md-table-cell>
          <md-table-cell :md-label="$I18n('active_time')">{{ item.active_date }}</md-table-cell>
          <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_date }}</md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
      </md-table>
      <!-- 翻页 -->
      <div style="margin-left: auto;">
        <table-page-v2 :showTotal="true" :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </div>
    </div>

  </div>
</template>
<script>
import { timestampToString } from "@/common/tools.js";

export default {
  data() {
    return {
      openModifyModal  : false,
      modalModifyTitle : "",
      modalModifyType  : "add",

      modalSearchData : { // 弹窗-表单-检索数据
        sycn_state : 0,
        order_state : 0,
      },
      searchForm : { // 表单-表单数据
        searchType : "cdk",
        searchValue: "",
        state      : 0,
        comp_id    : this.UserInfo.comp_id,
      },
      searchData : { // 表格-检索数据
        order_id : "",
        cdk      : "",
        state    : 0,
        comp_id  : this.UserInfo.comp_id,
      },
      icon  : "computer", // ICON
      title : this.$I18n("search_active_code"), // 卡片标题
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      productData:[],
      specData : [],
      selectedSpec: {},
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getComp()
      .then(() => {
        this.api_getPageData();
      })
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        sycn_state  : this.modalSearchData.sycn_state,
        order_state : this.modalSearchData.order_state,
      }
    },
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 公司
          let company  = this.$I18n("unknow");
          this.compData.forEach(function(com){
              if(com.comp_id == item.comp_id){
                company = com.comp_short_name ?com.comp_short_name :com.comp_name;
              }
          })
          // 状态
          let state_name = "";//this.$I18n('unknown')
          switch(item.state){
            case "1":
            case 1:
              state_name = this.$I18n("used");
              break;
            case "2":
            case 2:
              state_name = this.$I18n("to_be_used");
              break;
            case "3":
            case 3:
              state_name = this.$I18n("is_outfo_date");
              break;
            case "0":
            case 0:
            default:
              state_name = this.$I18n("unknown");
              break;
          }
          return {
            state_name,
            company,
            create_date : item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
            expire_date : item.gmt_expire ?timestampToString(item.gmt_expire * 1000) :"",
            active_date : item.gmt_active ?timestampToString(item.gmt_active * 1000) :"",
            ... item,
          }
        })
      }
    },
  },
  methods: {
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getActCode({ // api: /iot/uid/reg/query
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    api_getComp (){ // API-获取公司信息
      //获取菜单
      return this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("",() => {
          this.compData = [];
          this.total = 0;
        }))
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        cdk      : this.searchForm.searchType === "cdk" ?this.searchForm.searchValue :"",
        order_id : this.searchForm.searchType === "order_id" ?this.searchForm.searchValue :"",
        comp_id  :  this.searchForm.comp_id,
        state: parseInt(this.searchForm.state),
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
